module.exports = __webpack_public_path__ + "img/1f621.c4e8989.svg";